import styled from 'styled-components'

const DARK = '#284047'
const ACCENT = '#fdbd57'

// Styles used only by the login / forgot-password views.

export const Page = styled.div`
    align-items: center;
    background-color: ${DARK};
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    min-height: 100%;
    padding: 48px 16px 24px 16px;
    position: absolute;
    width: 100%;
`

export const Card = styled.div`
    background-color: white;
    border-radius: 12px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25);
    box-sizing: border-box;
    color: ${DARK};
    max-width: 400px;
    padding: 32px 32px 28px 32px;
    width: 100%;

    @media (max-width: 400px) {
        padding: 24px 20px;
    }
`

export const LogoWrap = styled.div`
    margin-bottom: 20px;

    & > div {
        height: 56px;
        min-height: 0;
        margin: 0 auto;
        width: 100%;
    }
`

export const CardTitle = styled.h1`
    font-size: 22px;
    font-weight: 700;
    margin: 0 0 8px 0;
    text-align: center;
`

export const CardText = styled.p`
    color: #55656b;
    font-size: 14px;
    line-height: 1.5;
    margin: 0 0 20px 0;
    text-align: center;
`

export const Field = styled.div`
    margin-bottom: 16px;
`

export const FieldLabel = styled.label`
    display: block;
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 6px;
`

export const FieldInput = styled.input`
    background-color: ${props => props.$error ? '#fdf0f1' : 'white'};
    border: 1px solid ${props => props.$error ? '#d00000' : '#c5cfd3'};
    border-radius: 8px;
    box-sizing: border-box;
    color: ${DARK};
    font-size: 16px;
    height: 46px;
    padding: 0 12px;
    width: 100%;

    &:focus {
        border-color: ${props => props.$error ? '#d00000' : ACCENT};
        box-shadow: 0 0 0 3px ${props => props.$error ? 'rgba(208, 0, 0, 0.15)' : 'rgba(253, 189, 87, 0.45)'};
        outline: none;
    }
`

export const FieldError = styled.div`
    color: #d00000;
    font-size: 13px;
    margin-top: 6px;
`

export const PrimaryButton = styled.button`
    background-color: ${DARK};
    border: none;
    border-radius: 8px;
    color: white;
    cursor: pointer;
    font-size: 16px;
    font-weight: 700;
    height: 48px;
    letter-spacing: 0.5px;
    margin-top: 8px;
    width: 100%;

    &:hover {
        background-color: #1d2f35;
    }

    &:focus-visible {
        box-shadow: 0 0 0 3px rgba(253, 189, 87, 0.7);
        outline: none;
    }

    &:active {
        transform: scale(0.98);
    }
`

export const LinkButton = styled.button`
    background: none;
    border: none;
    color: ${DARK};
    cursor: pointer;
    display: block;
    font-size: 14px;
    font-weight: 600;
    margin: 16px auto 0 auto;
    padding: 4px 8px;
    text-decoration: underline;

    &:hover {
        color: #1d2f35;
    }
`

export const SuccessBox = styled.div`
    background-color: #e3f6ea;
    border-radius: 8px;
    color: #1c5b34;
    font-size: 14px;
    line-height: 1.5;
    margin-bottom: 16px;
    padding: 14px 16px;
    word-break: break-word;
`

export const Warning = styled.div`
    background-color: white;
    border-radius: 8px;
    box-sizing: border-box;
    color: #d00000;
    font-size: 14px;
    margin-bottom: 20px;
    max-width: 400px;
    padding: 14px 16px;
    text-align: center;
    width: 100%;
`

export const Terms = styled.div`
    border-top: 1px solid #e3e8ea;
    font-size: 12px;
    margin-top: 20px;
    padding-top: 16px;
    text-align: center;

    & a {
        color: #55656b;
        text-decoration: underline;
    }

    & h6 {
        font-size: 12px;
        font-weight: 400;
        margin: 0;
    }
`
